import React, { useContext } from "react";
import { observer } from "mobx-react";

import classNames from "classnames";
import BetStatus from "./BetStatus";
import { MyBetsBetContext } from "@state/context/my-bets/MyBetsBetContext";
import BetItemCashout from "@features/my-bets/desktop/additional-offer/cashout/BetItemCashout";
import ShareBetSlipButton from "@features/my-bets/desktop/common/ShareBetSlipButton";
import AutosellButton from "@features/my-bets/desktop/additional-offer/tab-item/AutosellButton";

export default observer(function BetItemCardHeader() {
	const bet = useContext(MyBetsBetContext);

	if (!bet.betStatus) {
		return null;
	}

	return (
		<div className={classNames("card--bet__title")}>
			<BetStatus />
			<div
				className={classNames("card--bet__actions no-print", {
					"card--bet__actions--full": bet.isCashoutUnavailable,
				})}
			>
				<BetItemCashout />
				<AutosellButton />
				<ShareBetSlipButton bet={bet} isIconOnly isMini />
			</div>
		</div>
	);
});
